import React from 'react';
import queryString from 'query-string';
import {connect} from 'react-redux';
import {API_TASK_ASSIGN_POST_SUCCESS} from 'common/types';
import ApiActions from 'go/actions/api';
import REST from 'go/requests/rest';
import {ContentDispatch} from 'framework';
import {
  HOME,
  DETAILS_TITLE,
} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Container, Loader, Header, Form, Pagination} from 'semantic-ui-react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {Grid} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import BulkTaskFilter from './bulkTaskList/BulkTaskFilter';
import {Alert} from 'componentLibrary';
import camundaTaskVars from 'app-ui-componentlibrary/dist/go/components/common/workflow/camundaTaskVars';
import {Redirect} from 'react-router-dom';
import _ from 'lodash';
import {
  getUserEntitiesForEntityType,
  compileContent,
  retrieveRolesFromPermissions,
} from 'common/utils';
import {API_TASK_UNASSIGN_SUCCESS, API_CONFIG_GET_SUCCESS} from 'common/types';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {Select, InlineSelect} from 'app-ui-componentlibrary';
import BulkTaskResults from './bulkTaskList/BulkTaskResults';
import {FemaGoModal} from 'app-ui-componentlibrary';
import customWorkBooks from 'go/components/modules/excelWorkBooks';
import REGION_OPTIONS from './taskList/regions';
import {TASK_CONFIG, PARTITION_TYPES} from './bulkTaskList/BulkTaskConfig';
import produce from 'immer';
import {retrieveEntityTypeIdsFromPermissions} from 'app-ui-componentlibrary/dist/common/utils';

const LOCAL_STORAGE_KEY = 'bulkTasksFilter';
const LOCAL_STORAGE_KEY_SORT = 'bulkTasksSort';

const CLEAR_FILTERS = {
  grantId: '',
  subGrantId: '',
  organizationState: '',
  assignee: '',
  fundingOpportunityNumber: '',
  organizationName: '',
  subOrganizationName: '',
  region: '',
  roleDisplay: '',
  phase: '',
  name: '',
  followUpRequired: '',
  createdAfter: '',
  createdBefore: '',
};

const PRIORITY = 'priority';
const CREATED = 'created';

const DEFAULT_PAGE_SIZE = 25;

const CLEAR_SORT = {
  sortBy: PRIORITY,
  sortOrder: 'asc',
};
const COMPLETE = 'complete';
const UPDATE_PROCESS_VARIABLES = 'updateProcessVariables';
const EXPORT_DATA = 'exportData';

export class BulkTaskList extends React.Component {
  constructor(props) {
    super(props);
    const query = queryString.parse(_.get(this.props, 'location.search'));
    const taskName = query.taskName;
    const taskDefinitionKey = query.taskDefinitionKey;
    const processDefinitionKey = query.processDefinitionKey;
    this.exportRef = React.createRef();

    const filtersFromStorage = this.getStoredFilters(LOCAL_STORAGE_KEY);
    const initialFilters = filtersFromStorage ? filtersFromStorage : CLEAR_FILTERS;

    const sortFromStorage = this.getStoredFilters(LOCAL_STORAGE_KEY_SORT);
    const initialSort = sortFromStorage ? sortFromStorage : CLEAR_SORT;

    const permissions = _.get(this.props.auth, 'permissions');

    let userEntityTypeIds = retrieveEntityTypeIdsFromPermissions(permissions);

    let userEntityTypes = _.map(userEntityTypeIds, (id) => {
      return _.find(_.values(ENTITY_MAP), (entityType) => entityType.code == id);
    });

    if (
      _.includes(retrieveRolesFromPermissions(permissions), '23') &&
      !_.includes(userEntityTypeIds, '4')
    ) {
      userEntityTypes.push(ENTITY_MAP.PANEL_REVIEW);
    }

    userEntityTypes = _.map(userEntityTypes, (entityType) => {
      return {
        entityTypeId: parseInt(entityType.code),
        entityTypeName: entityType.label,
      };
    });

    this.state = {
      taskName: taskName,
      taskDefinitionKey: taskDefinitionKey,
      processDefinitionKey: processDefinitionKey,
      partitionType: props.partitionType ? props.partitionType : 'fo',
      processVariableId: 'fundingOpportunityId',
      selectionName: 'fundingOpportunityName',
      label: 'funding opportunity',
      reloadConfiguration: true,
      initializingConfig: true,
      filterSet: 0,
      error: false,
      firstResult: 0,
      activePage: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      filters: initialFilters,
      filtersAsEntered: initialFilters,
      sortOptions: initialSort,
      defaultSortOptions: initialSort,
      results: undefined,
      assigneeList: [],
      userObjs: [],
      selectionOptions: [],
      selectionIds: [],
      selectionValues: [],
      userEntityTypes: userEntityTypes,
      masterChecked: false,
      modalProcessing: false,
      initializingSelections: true,
    };
  }

  componentDidMount() {
    document.title = this.state.taskName
      ? `${HOME} - ${this.state.taskName}`
      : DETAILS_TITLE;
    let configKey = `${this.state.processDefinitionKey}.${this.state.taskDefinitionKey}`;
    if (_.includes(_.get(this.props, 'toggles.toggles'), 'teamManagementExpansion')) {
      configKey = `${configKey}.teamManagementExpansion`;
    }
    let config = TASK_CONFIG[configKey];
    if (config) {
      let {partitionType, configPath} = {...config};
      let {processVariableId, selectionName, label} = {...PARTITION_TYPES[partitionType]};
      this.setState(
        {
          partitionType,
          configPath,
          processVariableId,
          selectionName,
          label,
        },
        this.initializeVariables
      );
    } else {
      this.initializeVariables();
    }
  }

  componentDidUpdate() {
    const {
      selectionOptions,
      selectionIds,
      selectionValues,
      currentSelection,
      results,
      masterChecked,
      initializingConfig,
      initializingData,
      reloadConfiguration,
      initializingSelections,
    } = this.state;

    if (
      !_.isEmpty(selectionIds) &&
      !_.isEmpty(selectionValues) &&
      _.isEmpty(selectionOptions) &&
      !initializingSelections
    ) {
      this.setSelectionOptions(selectionIds, selectionValues);
    }

    if (currentSelection && reloadConfiguration) {
      this.getConfig(currentSelection);
    }
    if (
      currentSelection &&
      !initializingConfig &&
      !initializingData &&
      results == undefined
    ) {
      this.setState(
        {
          initializingData: true,
        },
        this.fetchMoreData
      );
    }

    if (results) {
      let numberChecked = this.getNumberOfSelectedRows(),
        numberCheckAble = 0;
      _.forEach(results, (result) => {
        if (this.isEntrySelectable(result)) {
          numberCheckAble++;
        }
      });
      if (numberCheckAble === numberChecked && numberChecked > 0) {
        if (_.isEqual(masterChecked, false)) {
          this.setState({masterChecked: true});
        }
      } else if (_.isEqual(masterChecked, true)) {
        this.setState({masterChecked: false});
      }
    }
  }

  initializeVariables = () => {
    const {partitionType, processVariableId} = this.state;
    this.getVariableValuesForTasks(processVariableId);
    this.fetchAssignedTo();
    const userPrograms = getUserEntitiesForEntityType(
      this.props.permissions,
      ENTITY_MAP.PROGRAM.code
    );
    const userFOs = getUserEntitiesForEntityType(
      this.props.permissions,
      ENTITY_MAP.FUNDING_OPPORTUNITY.code
    );
    if (partitionType === 'fo' || partitionType === 'program') {
      let selectionPromises = [];
      _.forEach(userPrograms, (programId) => {
        if (partitionType === 'fo') {
          selectionPromises.push(
            REST.fundingOpportunity
              .getFundingOpportunitiesForProgram(this.props.token, programId)
              .then((response) => response.json())
          );
        } else {
          selectionPromises.push(
            REST.program
              .getProgramById(this.props.token, programId)
              .then((response) => response.json())
          );
        }
      });
      if (partitionType === 'fo') {
        _.forEach(userFOs, (foId) => {
          selectionPromises.push(
            REST.fundingOpportunity
              .getFundingOpportunity(this.props.token, foId)
              .then((response) => response.json())
              .then((response) => {
                return {
                  payload: JSON.stringify({
                    fundingOpportunities: [response],
                  }),
                };
              })
          );
        });
      }

      Promise.all(selectionPromises)
        .then((selectionResults) => {
          let selectionValues = this.state.selectionValues || [];
          _.forEach(selectionResults, (result) => {
            let payload = JSON.parse(result.payload);
            selectionValues =
              partitionType === 'fo'
                ? _.concat(selectionValues, _.get(payload, 'fundingOpportunities'))
                : _.concat(selectionValues, result);
          });
          this.setState({
            selectionValues: selectionValues,
            selectionOptions: [],
            initializingSelections: false,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (partitionType === 'userEntityType') {
      this.setState({
        selectionValues: this.state.userEntityTypes,
        selectionOptions: [],
        initializingSelections: false,
      });
    } else if (partitionType === 'roleCategory') {
      REST.user
        .searchAssignablePermissions([])
        .then((response) => response.json())
        .then((response) => {
          let entityTypesICanAssign = [];
          if (response.dropdownMap) {
            entityTypesICanAssign = _.filter(
              _.values(ENTITY_MAP),
              (entityType) => response.dropdownMap[entityType.code]
            );
          }
          if (
            _.includes(retrieveRolesFromPermissions(this.props.permissions), '23') &&
            !_.find(
              entityTypesICanAssign,
              (entityType) => entityType.code === ENTITY_MAP.PANEL_REVIEW.code
            )
          ) {
            entityTypesICanAssign.push(ENTITY_MAP.PANEL_REVIEW);
          }
          if (
            _.includes(
              retrieveEntityTypeIdsFromPermissions(this.props.permissions),
              '3'
            ) &&
            !_.find(
              entityTypesICanAssign,
              (entityType) => entityType.code === ENTITY_MAP.FEMA_SYSTEM.code
            )
          ) {
            entityTypesICanAssign.push(ENTITY_MAP.FEMA_SYSTEM);
          }
          this.setState({
            selectionValues: _.map(entityTypesICanAssign, (entityType) => {
              return {
                entityTypeId: entityType.code,
                entityTypeName: entityType.label,
              };
            }),
            selectionOptions: [],
            initializingSelections: false,
          });
        });
    }
  };

  setSelectionOptions = (selectionIds, selectionValues) => {
    const {processVariableId, selectionName} = this.state;
    let newOptions = _.compact(
      _.map(selectionIds, (id) => {
        let selection = _.find(
          selectionValues,
          (selection) => (selection || {})[processVariableId] == parseInt(id)
        );
        if (selection) {
          let name = selection[selectionName];
          return {value: id, text: name};
        } else return null;
      })
    );
    let availableSelectionIds = _.filter(selectionIds, (id) => {
      return _.find(
        selectionValues,
        (selection) => (selection || {})[processVariableId] == parseInt(id)
      );
    });

    if (
      !_.isEqual(this.state.selectionOptions, newOptions) ||
      !_.isEqual(this.state.currentSelection, availableSelectionIds[0])
    ) {
      this.setState({
        selectionOptions: newOptions,
        currentSelection: availableSelectionIds[0],
      });
    }
  };

  getStoredFilters = (key) => {
    const {id} = this.props;
    const filter = JSON.parse(localStorage.getItem(key)) || {};
    if (filter) {
      if (filter.userId !== id) {
        localStorage.setItem(key, JSON.stringify({}));
      } else return filter;
    }
    return {};
  };

  loadPossibleFilterValues = () => {
    const enumeratedFilters = _.get(this.props.config, 'enumeratedFilters');
    const {taskDefinitionKey} = this.state;
    let filterMap = [];
    // Extended to loop through list
    _.forEach(enumeratedFilters, (filter) => {
      var filterName = filter.name;
      REST.workflow
        .getVariableValuesForTask(this.props.token, taskDefinitionKey, filterName)
        .then(REST.handler.handleResponse)
        .then((resJson) => {
          filterMap.push({[filterName]: _.sortedUniq(resJson)});
          this.setState({
            variableValues: filterMap,
          });
        })
        .catch((error) => {
          console.error('error');
        });
    });
  };

  getVariableValuesForTasks = (variableName) => {
    const parsed = queryString.parse(_.get(this.props, 'location.search'));
    const taskDefKey = parsed.taskDefinitionKey;

    REST.workflow
      .getVariableValuesForTask(this.props.token, taskDefKey, variableName)
      .then((response) => response.json())
      .then((resJson) => {
        this.setState({
          selectionIds: resJson,
        });
      })
      .catch((error) => {
        console.error('error');
      });
  };

  getConfig = (currentSelection) => {
    const {auth, toggles, profile} = this.props;
    const parsed = queryString.parse(_.get(this.props, 'location.search'));
    let configType = this.state.partitionType;
    let configEntityId = currentSelection;
    let configDefinition = 'taskDefinition';
    let entityType = parsed.taskDefinitionKey + 'Bulk';
    const configPath = this.state.configPath;

    if (configPath) {
      [configType, configEntityId, configDefinition, entityType] = [
        ..._.split(configPath, '.'),
      ];
    }

    this.setState(
      {
        reloadConfiguration: false, // avoid making the call in the interim
      },
      () => {
        this.props
          .getConfig(
            this.props.token,
            configType,
            configEntityId,
            configDefinition,
            entityType
          )
          .then((res) => {
            if (res && res.type === API_CONFIG_GET_SUCCESS) {
              let data = {};
              const config = res.payload;
              const pageSize = _.get(config, ['pageSizes', 0], DEFAULT_PAGE_SIZE);
              this.props.init({
                config,
                data,
                context: {
                  auth,
                  toggles,
                  profile,
                },
              });
              this.setState({
                initializingConfig: false,
                sortOptions: this.props.config.initialSort,
                defaultSortOptions: this.props.config.initialSort,
                pageSize,
              });
            } else {
              this.setState(
                {
                  error: true,
                },
                reject
              );
            }
          })
          .catch((error) => {
            console.error('error');
          });
      }
    );
  };

  fetchAssignedTo() {
    REST.workflow
      .getAssignedTo(this.props.token)
      .then((response) => response.json())
      .then((resJson) => {
        this.setState(
          {
            assigneeList: resJson,
          },
          () => {
            const notNull = _.filter(resJson, (userId) => userId !== null);
            this.getRoles(notNull);
          }
        );
      })
      .catch((error) => {
        console.error('error');
      });
  }

  getRoles = (userListinput) => {
    const fetchBody = {
      userId: [],
    };
    let count = 0;
    _.forEach(userListinput, (user, userKey) => {
      if (count == 0) {
        fetchBody.userId.push(user);
        count++;
      } else {
        fetchBody.userId.push(user);
      }
    });
    if (fetchBody.userId.length !== 0) {
      REST.user
        .getProfilesForUsers(this.props.token, fetchBody)
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            userObjs: data,
          });
        })
        .catch((error) => {
          console.error('error');
        });
    }
  };

  startTaskHandler = (id) => {
    let {assignTask, token} = this.props;
    assignTask(id, token).then((res) => {
      if (res && res.type === API_TASK_ASSIGN_POST_SUCCESS) {
        this.setState({taskId: id});
      }
    });
  };

  unassignTaskHandler = (id) => {
    const {unassignTask, token} = this.props;
    unassignTask(id, token).then((res) => {
      if (res && res.type === API_TASK_UNASSIGN_SUCCESS) {
        let data = this.state.results;
        let taskToUpdate = data[_.findIndex(data, {id})];
        taskToUpdate.assignee = null;
        this.setState({
          results: data,
          key: this.state.key + 1,
        });
      }
    });
  };

  onFilterChange = (filters, resetSort) => {
    const {id} = this.props;
    filters.userId = id;
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filters));
    const transformedFilters = this.transformFilters(filters);
    this.onFilterChangeHelper(filters, transformedFilters, resetSort);
  };

  onFilterChangeHelper = (filters, transformedFilters, resetSort) => {
    const {id} = this.props;
    const sortOptions = resetSort
      ? this.state.defaultSortOptions
      : this.state.sortOptions;
    localStorage.setItem(
      LOCAL_STORAGE_KEY_SORT,
      JSON.stringify({...sortOptions, userId: id})
    );

    this.setState({
      firstResult: 0,
      activePage: 1,
      filtersAsEntered: filters,
      filters: transformedFilters,
      results: undefined,
      filterSet: this.state.filterSet + 1,
      sortOptions,
    });
  };

  transformFilters = (filters) => {
    const transformedFilters = {};
    _.forEach(filters, (value, name) => {
      if (name === 'fundingOpportunityNumber') {
        value = _.get(
          _.find(
            _.get(this.state, 'fundingOpps', []),
            (fo) => fo.fundingOpportunityName === value
          ),
          'fundingOpportunityNr',
          value
        );
      }
      transformedFilters[name] = value;
    });
    return transformedFilters;
  };

  setSort = (sortOptions) => {
    const {id} = this.props;
    this.setState({
      sortOptions,
      activePage: 1,
      firstResult: 0,
      results: undefined,
      filterSet: this.state.filterSet + 1,
    });
    localStorage.setItem(
      LOCAL_STORAGE_KEY_SORT,
      JSON.stringify({...sortOptions, userId: id})
    );
  };

  fetchMoreData = _.debounce(
    () => {
      const {
        firstResult,
        filters,
        currentSelection,
        pageSize,
        processVariableId,
      } = this.state;
      const {config} = this.props;
      const paramsToOmit = ['taskName'];
      const parsed = _.omit(
        queryString.parse(_.get(this.props, 'location.search')),
        paramsToOmit
      );
      let fetchBody = {
        ...parsed,
        includeAssignedTasks: true,
        candidateGroups: this.props.permissions,
        processVariables: [],
        taskVariables: [],
        sorting: [],
      };
      if (filters['assignee'] == 'unassigned' || filters['assignee'] == null) {
        filters['assignee'] = null;
      }

      fetchBody.processVariables.push({
        name: processVariableId,
        value: parseInt(currentSelection),
        operator: 'eq',
      });

      const {sortOptions, defaultSortOptions} = this.state;
      const {sortBy, sortOrder, sortType} = sortOptions;

      if (_.includes(camundaTaskVars, sortOptions.sortBy)) {
        fetchBody.sorting.push({
          sortBy: sortBy,
          sortOrder: sortOrder,
        });
      } else {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: sortOrder,
          parameters: {
            variable: sortBy,
            type: sortType ? sortType : 'string',
          },
        });
      }

      if (sortBy !== defaultSortOptions.sortBy) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: defaultSortOptions.sortOrder,
          parameters: {
            variable: defaultSortOptions.sortBy,
            type: defaultSortOptions.sortType,
          },
        });
      }

      if (sortBy !== PRIORITY) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: 'asc',
          parameters: {
            variable: PRIORITY,
            type: 'string',
          },
        });
      }

      //Always add a sort by creation time
      if (sortBy !== CREATED) {
        fetchBody.sorting.push({
          sortBy: CREATED,
          sortOrder: 'asc',
        });
      }

      //Handle search filters...
      let enumeratedValues = this.state.variableValues;
      _.forEach(_.keys(filters), (key) => {
        let enumeratedObj = _.filter(enumeratedValues, (obj) => {
          return obj[key];
        });
        if (key !== 'userId') {
          if (filters[key] || filters[key] === 0 || filters[key] === false) {
            if (camundaTaskVars.indexOf(key) < 0) {
              let filterValue = filters[key];
              if (key === 'region') {
                for (let i = 0; i < REGION_OPTIONS.length; i++) {
                  if (REGION_OPTIONS[i].value === filterValue) {
                    filterValue = REGION_OPTIONS[i].text;
                  }
                }
              }
              if (
                typeof filterValue === 'string' &&
                key != 'region' &&
                _.isEmpty(enumeratedObj)
              ) {
                fetchBody.processVariables.push({
                  name: key,
                  value: `%${filterValue}%`,
                  operator: 'like',
                });
              } else {
                fetchBody.processVariables.push({
                  name: key,
                  value: filterValue,
                  operator: 'eq',
                });
              }
            } else {
              fetchBody[key] = filters[key];
            }
          }
        }
      });

      const currentFilterSet = this.state.filterSet;
      const configVariables = _.get(config, 'extraVariables', []);
      const variables = [
        'organizationId',
        'fundingOpportunityId',
        'programId',
        'entityTypeId',
        'priorityDisplay',
        'followUpRequired',
        ...configVariables,
      ];
      // Add extra columns from config
      const configColumns = _.chain(config)
        .get(['tableColumns'], [])
        .reduce((result, col) => {
          // Excluding columns that exist in Camunda
          if (col.type !== 'system') {
            result.push(col.key);
          }
          return result;
        }, [])
        .value();

      REST.workflow
        .getTasksWithVariables(
          this.props.token,
          fetchBody,
          _.union(variables, configColumns),
          pageSize,
          firstResult
        )
        .then((response) => response.json())
        .then((results) => {
          if (
            this.state.results == undefined ||
            currentFilterSet === this.state.filterSet
          ) {
            // weird async check to see if something else has happened since this started
            this.setState({
              results: results,
              initializingData: false,
            });
            this.loadPossibleFilterValues();
          }
        })
        .catch((error) => {
          this.setState({
            results: [],
            initializingData: false,
          });
          console.error('error');
        });

      REST.workflow
        .getTaskCount(this.props.token, fetchBody)
        .then((response) => response.json())
        .then((results) => {
          if (currentFilterSet === this.state.filterSet) {
            this.setState({
              taskCount: results.count,
            });
          }
        })
        .catch((error) => {
          console.error('error');
        });
    },
    250,
    {loading: true}
  );

  handleDropdownChange = (selection) => {
    this.setState({
      currentSelection: selection,
      results: undefined,
      initializingConfig: true,
      reloadConfiguration: true,
    });
  };

  handleCheckboxChange = (id, value) => {
    let data = this.state.results;
    let index = _.findIndex(data, {id}) || 0;
    const updatedData = produce(data, (draft) => {
      let taskToUpdate = _.get(draft, index);
      _.set(taskToUpdate, 'checked', value);
    });

    this.setState({
      results: updatedData,
    });
  };

  isEntrySelectable = (entry) => {
    const {config} = this.props;
    const disableFlagForFollowup = _.get(config, 'disableFlagForFollowup');
    if (
      (disableFlagForFollowup || entry.followUpRequired != true) &&
      (!entry.assignee || entry.assignee === this.props.userId) &&
      !_.isEqual(_.get(entry, 'userId'), this.props.userId) &&
      !_.isEqual(_.get(entry, 'excludedPerformer'), this.props.userId)
    ) {
      return true;
    }
    return false;
  };

  handleMasterCheckbox = (value) => {
    let data = produce(this.state.results, (draftResults) => {
      _.forEach(draftResults, (entry) => {
        if (this.isEntrySelectable(entry)) entry.checked = value;
      });
    });

    this.setState({
      results: data,
    });
  };

  handlePageChange = (activePage) => {
    const {pageSize} = this.state;
    const firstResult = pageSize * (activePage - 1);
    this.setState({
      firstResult: firstResult,
      activePage: activePage,
      results: undefined,
      taskCount: undefined,
    });
  };

  handlePageSize = (value) => {
    this.setState(
      {
        pageSize: value,
      },
      () => this.handlePageChange(this.state.activePage)
    );
  };

  renderTasks = () => {
    const {
      results,
      userObjs,
      selectionOptions,
      currentSelection,
      pageSize,
      masterChecked,
      taskCount,
      activePage,
      partitionType,
      label,
    } = this.state;
    const {config} = this.props;
    const {userId} = this.props;
    const pageSizes = [];
    const summary = _.get(config, 'summary');
    const disableFlagForFollowup = _.get(config, 'disableFlagForFollowup');

    _.forEach(config.pageSizes, (pageSize) => {
      pageSizes.push({key: pageSize, value: pageSize, text: pageSize});
    });

    const configActions = _.reduce(
      (config || {}).actions,
      (result, action) => {
        result.push({
          key: action.key,
          text: action.name,
          value: action.key,
        });
        return result;
      },
      []
    );

    const actions = [
      {
        key: '',
        value: '',
        text: '',
      },
      ...configActions,
    ];

    return (
      <Grid.Column width={12}>
        <h5>{`Select a ${label}`}</h5>
        <Form>
          <Select
            key={`${partitionType}Form`}
            placeholder={label}
            id={partitionType}
            search
            selection
            title={partitionType}
            name={partitionType}
            value={currentSelection}
            handleChange={(e) => this.handleDropdownChange(e.target.value)}
            options={selectionOptions}
            className={'FO-select'}
          />
        </Form>
        {results && results.length > 0 ? (
          <React.Fragment>
            <BulkTaskResults
              results={results}
              summary={summary}
              assignTask={this.startTaskHandler}
              unassignTask={this.unassignTaskHandler}
              userObjs={userObjs}
              userId={userId}
              columns={config.tableColumns}
              handleCheckboxChange={this.handleCheckboxChange}
              masterChecked={masterChecked}
              handleMasterCheckbox={this.handleMasterCheckbox}
              disableFlagForFollowup={disableFlagForFollowup}
            />

            <div className="batch-action-select">
              <InlineSelect
                key="batchActionSelect"
                placeholder="--"
                id="batchAction"
                search
                selection
                title="Select Batch Action"
                name="selectedAction"
                label="Select an action"
                value=""
                handleChange={this.onSelectBulkAction}
                options={actions}
                disabled={this.getNumberOfSelectedRows() === 0 || actions.length === 0}
              />
            </div>

            <div className="pagination-wrapper pagination">
              <Pagination
                totalPages={Math.ceil(taskCount / pageSize)}
                activePage={activePage}
                onPageChange={(e, data) => this.handlePageChange(data.activePage)}
              />
            </div>
            <div className="pagination-wrapper page-size">
              <InlineSelect
                placeholder="Show"
                title="Show"
                value={pageSize}
                name="pageSize"
                id="pageSize"
                label="Show"
                handleChange={(e) => this.handlePageSize(e.target.value)}
                options={pageSizes}
              />
            </div>
          </React.Fragment>
        ) : (
          <Alert header="No tasks available" type="info">
            There were no tasks found that match your filter criteria.
          </Alert>
        )}
      </Grid.Column>
    );
  };

  renderShowInfo = () => {
    const {results} = this.state;
    const {config} = this.props;

    const showInfoHeader = _.get(config, 'showInfo.showInfoHeader');
    const showInfoContent = _.get(config, 'showInfo.showInfoContent');
    const showInfo = _.get(config, 'showInfo');

    return (
      <React.Fragment>
        {showInfo && results && results.length > 0 ? (
          <Alert
            key="infoMessage"
            header={showInfoHeader}
            content={showInfoContent}
            type="info"
            dismissable
          />
        ) : (
          ''
        )}
      </React.Fragment>
    );
  };

  renderMessages = (showSuccess, showError) => {
    if (showSuccess || showError) {
      const {
        processingAction,
        taskCompleted,
        tasksUnsuccessful,
        selectedResults,
      } = this.state;
      const submissionVariables = _.get(this.props, 'submissionVariables', {});

      const unsuccessGrants = _.reduce(
        selectedResults,
        (result, selected) => {
          if (_.indexOf(tasksUnsuccessful, selected.taskId) > -1) {
            result.push(selected.grantId);
          }
          return result;
        },
        []
      );
      const unsuccessSubGrants = _.reduce(
        selectedResults,
        (result, selected) => {
          if (_.indexOf(tasksUnsuccessful, selected.taskId) > -1) {
            result.push(selected.subGrantId);
          }
          return result;
        },
        []
      );
      const modalConfig = _.get(processingAction, 'modal', {});

      const successMessageHeader = modalConfig.successMessageHeader;
      const successMessageContent = compileContent(modalConfig.successMessageContent, {
        grantsCount: _.size(taskCompleted),
        ...submissionVariables,
      });
      const errorMessageHeader = modalConfig.errorMessageHeader;
      const errorMessageContent = compileContent(modalConfig.errorMessageContent, {
        grantsCount: _.size(tasksUnsuccessful),
        grantIds: _.join(unsuccessGrants, ', '),
        subGrantIds: _.join(unsuccessSubGrants, ', '),
        ...submissionVariables,
      });

      return (
        <React.Fragment>
          {showSuccess && taskCompleted && taskCompleted.length > 0 ? (
            <Alert
              key="successMessage"
              header={successMessageHeader}
              content={successMessageContent}
              type="success"
              onDismiss={() => this.setState({showSuccessMessage: false})}
              dismissable
            />
          ) : (
            ''
          )}
          {showError && tasksUnsuccessful && tasksUnsuccessful.length > 0 ? (
            <Alert
              key="failureMessage"
              header={errorMessageHeader}
              content={errorMessageContent}
              type="error"
              onDismiss={() => this.setState({showErrorMessage: false})}
              dismissable
            />
          ) : (
            ''
          )}
        </React.Fragment>
      );
    }
  };

  renderModal = () => {
    const {
      selectionOptions,
      selectedBulkAction,
      isBulkModalOpen,
      currentSelection,
      modalProcessing,
    } = this.state;
    const {config, selectedTasks} = this.props;
    const submissionVariables = _.get(this.props, 'submissionVariables', {});

    const selectedCount = this.getNumberOfSelectedRows();
    const fo =
        _.isArray(selectionOptions) && selectionOptions.length > 0 && currentSelection
          ? _.find(selectionOptions, (fo) => {
              return fo.value === currentSelection;
            })
          : {},
      foName = (fo || {}).text;

    const selectionName = foName;
    const selectedSubAndGrantIds = this.getSelectedGrantsAndTaskIds();
    const subGrantIds = selectedSubAndGrantIds.subGrantIds;
    const selectedBulkActionConfig = _.find(
      _.get(config, 'actions', []),
      (action) => action.key === selectedBulkAction
    );
    const exportColumns = _.get(selectedBulkActionConfig, 'exportColumns');
    const exportName = _.get(selectedBulkActionConfig, 'exportName');
    const modalConfig = _.get(selectedBulkActionConfig, 'modal');
    const modalTitle = _.get(modalConfig, 'modalTitle', '');
    const modalContent = compileContent(_.get(modalConfig, 'modalContent', ''), {
      selectedCount,
      foName,
      selectionName,
      subGrantIds,
      ...submissionVariables,
    });
    const modalSubmitText = _.get(modalConfig, 'modalSubmitButton', 'Confirm');
    const contents = _.get(modalConfig, 'contents', []);
    let validationsSuccesful = this.props.allValid;
    const isExportAction = _.get(selectedBulkActionConfig, 'type') === EXPORT_DATA;
    const staticData = _.get(config, 'staticVariables', {});
    const exportData = _.map(selectedTasks, (task) =>
      _.extend({static: staticData}, task)
    );
    const CustomWorkbook = customWorkBooks[_.get(selectedBulkActionConfig, 'exportType')];
    return (
      <FemaGoModal
        title={modalTitle}
        buttonText={modalSubmitText}
        open={!!isBulkModalOpen}
        confirmAction={this.processBatchAction}
        cancelAction={() =>
          this.setState({
            isBulkModalOpen: false,
            selectedBulkAction: '--',
            selectedBulkActionName: '--',
            modalProcessing: false,
          })
        }
        disableButton={!validationsSuccesful || modalProcessing}
        htmlContent={modalContent}
      >
        {_.map(contents, (conf, index) => {
          let config = {
            ...conf,
          };
          return <ContentDispatch key={conf.id || index} config={config} />;
        })}
        {isExportAction && (
          <CustomWorkbook
            taskData={exportData}
            exportRef={this.exportRef}
            exportColumns={exportColumns}
            exportName={exportName}
          />
        )}
      </FemaGoModal>
    );
  };

  onSelectBulkAction = (e) => {
    if (!_.isEmpty(e.target.value)) {
      const {results} = this.state;
      const key = e.target.value;
      this.setState({
        selectedBulkAction: key,
        selectedBulkActionName: e.target.textContent,
        isBulkModalOpen: true,
        showSuccessMessage: false,
        showErrorMessage: true,
      });
      const actions = _.get(this.props.config, 'actions', []);
      const validationToRun = _.get(
        _.find(actions, (action) => action.key === key),
        'validations',
        []
      );
      this.props.saveEntitySessionData('context.bulkList', {
        selectedBulkActions: _.filter(results, (result) => result.checked),
      });
      this.props.validateWith(validationToRun);
    }
  };

  getNumberOfSelectedRows() {
    let count = 0;
    _.forEach(this.state.results, (result) => {
      if (result.checked) count++;
    });

    return count;
  }

  getSelectedGrantsAndTaskIds() {
    let taskIds = [],
      grantIds = [],
      subGrantIds = [],
      selectedResults = [];
    _.forEach(this.state.results, (result) => {
      if (result.checked) {
        taskIds.push(result.id);
        grantIds.push(result.grantId);
        subGrantIds.push(result.subGrantId);
        selectedResults.push({
          taskId: result.id,
          grantId: result.grantId,
          subGrantId: result.subGrantId,
        });
      }
    });
    grantIds = _.sortedUniq(grantIds);
    return {taskIds, grantIds, subGrantIds, selectedResults};
  }

  triggerExport = () => {
    this.exportRef.current.click();
  };

  transformProcessVariables = (taskPayload, submissionVariables) => {
    const {results, selectedTasks} = this.props;
    // Assumes outcome payload will only contain common values since all outcomes must be the same in endpoint
    const firstResult = _.get(selectedTasks, 0);
    const context = {
      ...submissionVariables,
      ...firstResult,
    };
    const transformed = {};
    _.forEach(taskPayload, (variable) => {
      transformed[variable.name] =
        variable.type === 'template'
          ? compileContent(variable.value, context)
          : variable.value;
    });
    return transformed;
  };

  processBulkUpdate = (selectedIds, action) => {
    const submissionVariables = _.get(this.props, 'submissionVariables', {});
    const taskPayload = this.transformProcessVariables(
      _.get(action, 'taskPayload', {}),
      submissionVariables
    );

    let bulkPayload = {
      taskIds: selectedIds.taskIds,
      payload: taskPayload,
    };

    return REST.workflow
      .bulkVariableUpdate(this.props.token, bulkPayload)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        // Refreshing data
        this.setState({
          taskCompleted: resJson.tasksUpdated,
          tasksUnsuccessful: resJson.tasksFailed,
          selectedResults: selectedIds.selectedResults,
          processingAction: action,
          results: undefined,
          showSuccessMessage: true,
        });
      });
  };

  // update DDS entity for each selected grant with payload
  batchDataUpdate = (payload) => {
    return REST.dynamicData
      .updateBatchData(this.props.token, payload)
      .then((res) => REST.handler.handleResponse(res, 'Batch data update failed.'));
  };

  // Complete each task and pass along process variable payload
  batchComplete = (selectedIds, payload, action) => {
    return REST.workflow
      .bulkComplete(this.props.token, selectedIds.taskIds, payload)
      .then((res) => REST.handler.handleResponse(res, 'Batch task completion failed.'))
      .then((resJson) => {
        // Refreshing data
        this.setState({
          taskCompleted: resJson.tasksCompleted,
          tasksUnsuccessful: resJson.tasksUnsuccessful,
          selectedResults: selectedIds.selectedResults,
          processingAction: action,
          showSuccessMessage: true,
          results: undefined,
        });
        return;
      });
  };

  processBulkComplete = (selectedIds, bulkAction) => {
    const taskPayload = _.get(bulkAction, 'taskPayload', {});
    const dataPayload = _.get(bulkAction, 'dataPayload', {});
    const entityType = _.get(dataPayload, 'entityType', '');
    const submissionVariables = _.get(this.props, 'submissionVariables', {});

    // transform task completion payload with template
    const taskPayloadTransformed = this.transformProcessVariables(
      taskPayload,
      submissionVariables
    );

    // transform data payload with template
    const dataPayloadTransformed = {};
    dataPayloadTransformed.grants = _.map(selectedIds.grantIds, (grantId) => ({
      grantId: grantId,
      entityType: entityType,
    }));
    dataPayloadTransformed.subGrants = _.map(selectedIds.subGrantIds, (subGrantId) => ({
      subGrantId: subGrantId,
      entityType: entityType,
    }));
    _.forEach(dataPayload.saveOnSubmit, (data) => {
      _.set(
        dataPayloadTransformed,
        data.dataPath,
        data.type === 'template'
          ? compileContent(data.value, submissionVariables)
          : data.value
      );
    });

    // Both will reject the promise if they fail
    let optionalDataUpdate =
      dataPayload && entityType ? this.batchDataUpdate : () => Promise.resolve();
    return optionalDataUpdate(dataPayloadTransformed).then(() =>
      this.batchComplete(selectedIds, taskPayloadTransformed, bulkAction)
    );
  };

  processBatchAction = () => {
    const selectedIds = this.getSelectedGrantsAndTaskIds();
    const {selectedBulkAction: bulkAction} = this.state;
    this.setState({modalProcessing: true});
    const {config} = this.props;
    const action = _.chain(config)
      .get('actions', [])
      .find((action) => {
        return action.key === bulkAction;
      })
      .value();

    const actionType = _.get(action, 'type', COMPLETE);

    let bulkHandler = (selectedIds, action) => {
      if (actionType === COMPLETE) {
        return this.processBulkComplete(selectedIds, action);
      } else if (actionType === UPDATE_PROCESS_VARIABLES) {
        return this.processBulkUpdate(selectedIds, action);
      } else if (actionType === EXPORT_DATA) {
        this.triggerExport();
        return Promise.resolve();
      }
    };

    bulkHandler(selectedIds, action)
      .catch((error) => {
        // Refreshing data
        this.setState({
          tasksUnsuccessful: selectedIds.taskIds,
          processingAction: action,
          selectedResults: selectedIds.selectedResults,
          showErrorMessage: true,
          results: undefined,
          modalProcessing: false,
        });
        console.error('Error processing grants' + error);
      })
      .finally(() => {
        this.setState({
          isBulkModalOpen: false,
          selectedBulkAction: '--',
          selectedBulkActionName: '--',
          modalProcessing: false,
        });
        if (document && document.getElementById('root'))
          document.getElementById('root').scrollTop = 0; // Workaround when window.scrollTo does not work
      });
  };

  render() {
    const {
      taskId,
      sortOptions,
      assigneeList,
      showSuccessMessage,
      showErrorMessage,
      taskNameList,
      userObjs,
      filters,
      filtersAsEntered,
      results,
      taskCount,
      taskName,
    } = this.state;
    const {config} = this.props;
    const sortReorder = _.includes(this.props.toggles?.toggles, 'disasterSiteNav');
    if (taskId) {
      return <Redirect to={`/tasks/${taskId}`} push />;
    } else {
      return (
        <Main>
          <Container fluid>
            {this.renderModal()}
            <Header as="h1">{taskName || 'Task List'}</Header>
            {this.renderShowInfo()}
            {this.renderMessages(showSuccessMessage, showErrorMessage)}
            <Grid doubling stackable reversed="mobile" padded="vertically">
              {config === undefined ? (
                <Loader inline="centered" active>
                  Loading...
                </Loader>
              ) : (
                <React.Fragment>
                  {sortReorder && (
                    <Grid.Column width={4} key="bulkListFilterColumn">
                      <BulkTaskFilter
                        key="bulkTaskFilter"
                        config={config}
                        onFilterChange={(filters) => this.onFilterChange(filters)}
                        onFilterClear={() => this.onFilterChange(CLEAR_FILTERS, true)}
                        assigneeList={assigneeList}
                        filters={filters}
                        sortOptions={sortOptions}
                        taskNameList={taskNameList}
                        userObjs={userObjs}
                        filtersAsEntered={filtersAsEntered}
                        variableValues={this.state.variableValues}
                        setSortBy={(sortBy, sortType) => {
                          this.setSort({
                            ...sortOptions,
                            sortBy,
                            sortType,
                          });
                        }}
                        setSortOrder={(sortOrder) => {
                          this.setSort({
                            ...sortOptions,
                            sortOrder,
                          });
                        }}
                      />
                    </Grid.Column>
                  )}
                  {results == undefined || taskCount == undefined ? (
                    <Loader inline="centered" active>
                      Loading...
                    </Loader>
                  ) : (
                    this.renderTasks()
                  )}
                  {!sortReorder && (
                    <Grid.Column width={4} key="bulkListFilterColumn">
                      <BulkTaskFilter
                        key="bulkTaskFilter"
                        config={config}
                        onFilterChange={(filters) => this.onFilterChange(filters)}
                        onFilterClear={() => this.onFilterChange(CLEAR_FILTERS, true)}
                        assigneeList={assigneeList}
                        filters={filters}
                        sortOptions={sortOptions}
                        taskNameList={taskNameList}
                        userObjs={userObjs}
                        filtersAsEntered={filtersAsEntered}
                        variableValues={this.state.variableValues}
                        setSortBy={(sortBy, sortType) => {
                          this.setSort({
                            ...sortOptions,
                            sortBy,
                            sortType,
                          });
                        }}
                        setSortOrder={(sortOrder) => {
                          this.setSort({
                            ...sortOptions,
                            sortOrder,
                          });
                        }}
                      />
                    </Grid.Column>
                  )}
                </React.Fragment>
              )}
            </Grid>
          </Container>
        </Main>
      );
    }
  }
}

export const mapDispatchToProps = (dispatch, props) => {
  return {
    init: (initState) => dispatch(DynamicComponentActions.initWithState(initState)),
    validateWith: (validationToRun) => {
      dispatch(DynamicComponentActions.setValidationsWith(validationToRun));
      dispatch(DynamicComponentActions.validateConfigRules());
    },
    assignTask: (id, token) => {
      const action = ApiActions.tasks.assignTask(id, token);
      const res = dispatch(action);
      return res;
    },
    unassignTask: (id, token) => {
      const action = ApiActions.tasks.unassignTask(token, id);
      const res = dispatch(action);
      return res;
    },
    getConfig: (token, entityType, entityId, configType, configId) => {
      let action = ApiActions.config.getConfig(
        token,
        entityType,
        entityId,
        configType,
        configId
      );
      const res = dispatch(action);
      return res;
    },
  };
};

export const mapStateToProps = (state) => {
  // things needed for bulk task submission context
  const userId = state.auth.userId;
  let submissionVariables = {
    ..._.get(state, 'dynamicComponent.context.bulkList.submissionVariables', {}),
    userId,
  };
  let allValid =
    !_.get(state, 'dynamicComponent.validationErrors.isLoading') &&
    _.get(state, 'dynamicComponent.validationErrors.allValid');
  return {
    id: state.auth.userId,
    token: state.auth.token,
    auth: state.auth,
    profile: state.profile,
    toggles: state.toggles,
    permissions: state.auth.permissions,
    config: _.get(state, 'dynamicComponent.config'),
    selectedTasks: _.get(state, 'dynamicComponent.context.bulkList.selectedBulkActions'),
    userId,
    submissionVariables,
    allValid,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(connectDynamic(BulkTaskList));
